/**
 * we have quite a few maps that are keyed on chatId
 * These are usually Record<string, T>
 * But that doesn't work with ChatIdentifier
 *  */
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _SafeMap_instances, _a, _SafeMap_isPrimitive, _SafeMap_serialise, _SafeMap_deserialise, _SafeMap_map, _SafeMap_newMap;
import { defaultDeserialiser, defaultSerialiser, } from "../domain";
export class SafeMap {
    constructor(serialiser, deserialiser, map) {
        _SafeMap_instances.add(this);
        _SafeMap_isPrimitive.set(this, void 0);
        _SafeMap_serialise.set(this, void 0);
        _SafeMap_deserialise.set(this, void 0);
        _SafeMap_map.set(this, void 0);
        __classPrivateFieldSet(this, _SafeMap_isPrimitive, serialiser === undefined && deserialiser === undefined, "f");
        __classPrivateFieldSet(this, _SafeMap_serialise, serialiser ?? defaultSerialiser, "f");
        __classPrivateFieldSet(this, _SafeMap_deserialise, deserialiser ?? defaultDeserialiser, "f");
        __classPrivateFieldSet(this, _SafeMap_map, map ?? new Map(), "f");
    }
    [(_SafeMap_isPrimitive = new WeakMap(), _SafeMap_serialise = new WeakMap(), _SafeMap_deserialise = new WeakMap(), _SafeMap_map = new WeakMap(), _SafeMap_instances = new WeakSet(), _SafeMap_newMap = function _SafeMap_newMap() {
        return __classPrivateFieldGet(this, _SafeMap_isPrimitive, "f")
            ? new _a(undefined, undefined)
            : new _a(__classPrivateFieldGet(this, _SafeMap_serialise, "f"), __classPrivateFieldGet(this, _SafeMap_deserialise, "f"));
    }, Symbol.iterator)]() {
        return this.entries();
    }
    map(fn) {
        const mapped = __classPrivateFieldGet(this, _SafeMap_instances, "m", _SafeMap_newMap).call(this);
        for (const [k, v] of this.entries()) {
            mapped.set(k, fn(k, v));
        }
        return mapped;
    }
    merge(other) {
        other.forEach((val, key) => {
            this.set(key, val);
        });
        return this;
    }
    filter(fn) {
        return [...this.entries()]
            .filter(([k, v]) => {
            return fn(v, k);
        })
            .reduce((agg, [k, v]) => {
            agg.set(k, v);
            return agg;
        }, __classPrivateFieldGet(this, _SafeMap_instances, "m", _SafeMap_newMap).call(this));
    }
    reduce(reducer, initialValue) {
        let acc = initialValue;
        for (const entry of this) {
            acc = reducer(acc, entry, this);
        }
        return acc;
    }
    clone() {
        const cloned = __classPrivateFieldGet(this, _SafeMap_instances, "m", _SafeMap_newMap).call(this);
        for (const [key, value] of this) {
            cloned.set(key, value);
        }
        return cloned;
    }
    empty() {
        return __classPrivateFieldGet(this, _SafeMap_instances, "m", _SafeMap_newMap).call(this);
    }
    clear() {
        __classPrivateFieldGet(this, _SafeMap_map, "f").clear();
    }
    values() {
        return __classPrivateFieldGet(this, _SafeMap_map, "f").values();
    }
    keys() {
        const entryIter = this[Symbol.iterator]();
        return {
            [Symbol.iterator]() {
                return this;
            },
            next() {
                const { done, value } = entryIter.next();
                if (done)
                    return { done, value: undefined };
                return { done: false, value: value[0] };
            },
        };
    }
    entries() {
        const deserialise = (s) => __classPrivateFieldGet(this, _SafeMap_deserialise, "f").call(this, s);
        const it = __classPrivateFieldGet(this, _SafeMap_map, "f").entries();
        return {
            [Symbol.iterator]() {
                return this;
            },
            next() {
                const result = it.next();
                if (result.done)
                    return { done: true, value: undefined };
                const [serialisedKey, value] = result.value;
                const originalKey = deserialise(serialisedKey);
                return { done: false, value: [originalKey, value] };
            },
        };
    }
    delete(key) {
        if (__classPrivateFieldGet(this, _SafeMap_map, "f").size === 0)
            return false;
        return __classPrivateFieldGet(this, _SafeMap_map, "f").delete(__classPrivateFieldGet(this, _SafeMap_serialise, "f").call(this, key));
    }
    forEach(callbackfn) {
        for (const [k, value] of __classPrivateFieldGet(this, _SafeMap_map, "f").entries()) {
            callbackfn(value, __classPrivateFieldGet(this, _SafeMap_deserialise, "f").call(this, k), this);
        }
    }
    get(key) {
        if (__classPrivateFieldGet(this, _SafeMap_map, "f").size === 0)
            return undefined;
        return __classPrivateFieldGet(this, _SafeMap_map, "f").get(__classPrivateFieldGet(this, _SafeMap_serialise, "f").call(this, key));
    }
    has(key) {
        if (__classPrivateFieldGet(this, _SafeMap_map, "f").size === 0)
            return false;
        return __classPrivateFieldGet(this, _SafeMap_map, "f").has(__classPrivateFieldGet(this, _SafeMap_serialise, "f").call(this, key));
    }
    set(key, value) {
        __classPrivateFieldGet(this, _SafeMap_map, "f").set(__classPrivateFieldGet(this, _SafeMap_serialise, "f").call(this, key), value);
        return this;
    }
    get size() {
        return __classPrivateFieldGet(this, _SafeMap_map, "f").size;
    }
    toMap() {
        return __classPrivateFieldGet(this, _SafeMap_map, "f");
    }
    static fromEntries(entries, serialiser, deserialiser) {
        const map = new _a(serialiser, deserialiser);
        for (const [k, v] of entries) {
            map.set(k, v);
        }
        return map;
    }
}
_a = SafeMap;
// This is a bit weird
export class GlobalMap extends SafeMap {
    constructor(_map) {
        super((_) => "global", (_) => "global", _map);
    }
}
export class ChatMap extends SafeMap {
    constructor(_map) {
        super((k) => JSON.stringify(k), (k) => JSON.parse(String(k)), _map);
    }
    static fromList(things) {
        return things.reduce((map, c) => {
            map.set(c.id, c);
            return map;
        }, new ChatMap());
    }
    static fromMap(map) {
        return new ChatMap(map);
    }
    static fromJSON(json) {
        return new ChatMap(new Map(JSON.parse(json)));
    }
}
export class MessageContextMap extends SafeMap {
    constructor(_map) {
        super((k) => JSON.stringify(k), (k) => JSON.parse(String(k)), _map);
    }
    static fromMap(map) {
        return new MessageContextMap(map);
    }
}
export class CommunityMap extends SafeMap {
    constructor() {
        super((k) => k.communityId, (k) => ({ kind: "community", communityId: String(k) }));
    }
    static fromList(things) {
        return things.reduce((map, c) => {
            map.set(c.id, c);
            return map;
        }, new CommunityMap());
    }
}
export class MessageMap extends SafeMap {
    constructor(entries) {
        super((k) => k.toString(), (k) => BigInt(k));
        if (entries !== undefined) {
            for (const [k, v] of entries) {
                this.set(k, v);
            }
        }
    }
}
export function getOrAdd(map, key, value) {
    const existing = map.get(key);
    if (existing !== undefined) {
        return existing;
    }
    map.set(key, value);
    return value;
}
